import { render } from "./a-header.vue?vue&type=template&id=0416bac2"
import script from "./a-header.vue?vue&type=script&lang=js"
export * from "./a-header.vue?vue&type=script&lang=js"

import "./a-header.vue?vue&type=style&index=0&id=0416bac2&lang=sass"

import exportComponent from "/opt/bitnami/apps/ocmsta/subdomains/projects-manager/htdocs/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__